/**
 * @generated SignedSource<<2d82898171685e4f2bd96872353b88cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationTomraScreen_RvmFragment$data = {
  readonly id: string | null;
  readonly name: string | null;
  readonly serialNumber: string;
  readonly " $fragmentType": "IntegrationTomraScreen_RvmFragment";
};
export type IntegrationTomraScreen_RvmFragment$key = {
  readonly " $data"?: IntegrationTomraScreen_RvmFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationTomraScreen_RvmFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationTomraScreen_RvmFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serialNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "IntegrationTomraRVM",
  "abstractKey": null
};

(node as any).hash = "97f94cf7effc67174237722b557d6fee";

export default node;
